<template>
<div class="concurrency-events-panel">
  <div class="o-main-content-area o-main-content-area--padBotoomNone">
    <div class="row c-responsive-fixwidth">
      <div class="col-md-8">
        <h1 class="h1">Traffic Trap &mdash; Concurrency Events</h1>
        <p class="c-small-help" style="color:#8b949e">
          Most recent requests rejected (or flagged, in flag mode) for exceeding the per-user in-flight ceiling. Auto-refreshes every 10s.
        </p>
      </div>
      <div class="col-md-4 text-right">
        <span style="color:#8b949e;font-size:0.85rem;margin-right:12px">
          {{ loading ? 'refreshing&hellip;' : lastRefresh ? 'last: ' + lastRefresh : '' }}
        </span>
        <a href="javascript: void(0)" class="c-common-btn c-common-btn--small" @click="fetchEvents">Refresh now</a>
      </div>
    </div>

    <div class="c-common-space c-common-box-shadow c-radius3" style="padding:14px">
      <table class="o-table-area" style="width:100%;font-size:0.88rem">
        <thead>
          <tr style="text-align:left">
            <th>Time</th>
            <th>User</th>
            <th>Role</th>
            <th>Client</th>
            <th>Route</th>
            <th style="text-align:right">In-flight</th>
            <th style="text-align:right">Limit</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!events.length && !loading">
            <td colspan="8" style="text-align:center;padding:18px;color:#8b949e">No events in window.</td>
          </tr>
          <tr v-for="(e, i) in events" :key="i">
            <td>{{ formatTime(e.time) }}</td>
            <td>{{ e.user_id }}</td>
            <td>{{ e.role }}</td>
            <td>{{ e.client_id || '&mdash;' }}</td>
            <td><code>{{ e.route }}</code></td>
            <td style="text-align:right">{{ e.inflight }}</td>
            <td style="text-align:right">{{ e.limit }}</td>
            <td>
              <a href="javascript: void(0)" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green"
                 :disabled="bypassing[e.user_id]"
                 @click="grantBypass(e)">Bypass 24h</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import service from '../../../services.js';

const REFRESH_MS = 10000;

export default {
  name: 'ConcurrencyEventsPanel',

  computed: {
    ...mapGetters({ userToken: 'userToken' }),
  },

  data() {
    return {
      events: [],
      loading: false,
      lastRefresh: '',
      bypassing: {},
      timer: null,
    };
  },

  mounted() {
    this.fetchEvents();
    this.timer = setInterval(this.fetchEvents, REFRESH_MS);
  },

  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },

  methods: {
    async fetchEvents() {
      this.loading = true;
      try {
        const res = await service.get('sa/traffic/concurrency-events', {
          Authorization: this.userToken,
        });
        const payload = res?.data?.result || res?.data || {};
        this.events = payload.events || [];
        this.lastRefresh = this.formatTime(Date.now());
      } catch (err) {
        console.log('ConcurrencyEventsPanel fetch failed:', err);
      } finally {
        this.loading = false;
      }
    },

    async grantBypass(event) {
      const email = prompt('Enter email to bypass for 24h (leave blank to cancel):');
      if (!email) return;
      this.$set(this.bypassing, event.user_id, true);
      try {
        await service.post('sa/traffic/bypass', { email, hours: 24 }, {
          Authorization: this.userToken,
        });
        this.$notify?.success?.({ title: 'Bypass set', message: email + ' bypassed for 24h' });
      } catch (err) {
        this.$notify?.error?.({ title: 'Bypass failed', message: err?.message || 'unknown error' });
      } finally {
        this.$set(this.bypassing, event.user_id, false);
      }
    },

    formatTime(ms) {
      if (!ms) return '';
      const d = new Date(Number(ms));
      return d.toLocaleTimeString();
    },
  },
};
</script>

<style scoped>
.concurrency-events-panel table th {
  padding: 8px 10px;
  border-bottom: 2px solid #30363d;
  color: #8b949e;
  font-weight: 600;
}
.concurrency-events-panel table td {
  padding: 7px 10px;
  border-bottom: 1px solid #21262d;
  vertical-align: top;
}
</style>
